import { sum } from 'ramda';

// The part of a flush result (solver output or DTO) that decides how the water arrives at the stope.
export interface WaterOutcome {
  timeToWaterAtStopeMinutes?: number | null;
  airStartWaterVolume?: number | null;
  stages: { durationMinutes: number }[];
}

const isFiniteNumber = (value: number | null | undefined): value is number => typeof value === 'number' && Number.isFinite(value);

// The planned water alone carries the front to the stope.
export const waterAloneReachesStope = ({ timeToWaterAtStopeMinutes }: WaterOutcome): boolean => isFiniteNumber(timeToWaterAtStopeMinutes);

// The planned water stops short, but the air purge can start within it and pushes the slug the rest of the way.
export const airPushesWaterToStope = (outcome: WaterOutcome): boolean => !waterAloneReachesStope(outcome) && isFiniteNumber(outcome.airStartWaterVolume);

// Minutes to pump the planned water, after which the air purge would begin.
export const plannedWaterMinutes = ({ stages }: WaterOutcome): number => sum(stages.map((stage) => stage.durationMinutes));

// The part of a flush result that says which pump drives the water into the line.
export interface PumpOutcome {
  pastePumpWaterVolume: number;
  pastePumpHandoverDistance: number;
  finalFlushVolume: number;
}

// Where the flush pump takes over from the paste pump. Undefined when the flush pump drives from the
// start, or when it never manages to take over within the planned water.
export const flushPumpHandoverDistance = ({ pastePumpWaterVolume, pastePumpHandoverDistance, finalFlushVolume }: PumpOutcome): number | undefined => (
  pastePumpWaterVolume > 0 && pastePumpWaterVolume < finalFlushVolume ? pastePumpHandoverDistance : undefined
);
